import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-page',
  templateUrl: './privacy-page.component.html',
  styleUrls: ['./privacy-page.component.css'],
  host: {
    class: 'app-page'
  }
})
export class PrivacyPageComponent {

}
